module.exports = __webpack_public_path__ + "img/mr-bts-hand-test-thumb.af83164f.jpg";